<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" :md="openEvent && !smAndDown ? 6 : 12">
        <v-card
          class="pb-1 mt-2 colorDominant"
          elevation="0"
          outlined
          :class="{
            'mr-1': openEvent && !smAndDown,
          }"
        >
          <v-progress-linear
            absolute
            indeterminate
            :active="loading"
          ></v-progress-linear>
          <v-tabs v-model="tab" show-arrows background-color="colorDominant">
            <v-tab
              class="colorDominant"
              v-for="(tab, i) in listSports"
              :key="i"
              :value="`${tab}`"
              @click="
                $router
                  .push({
                    name: 'favorites',
                    params: { sport: tab.id_sport },
                    query: { sport: tab.name_sport, id_sport: tab.id_sport },
                  })
                  .catch(() => {})
              "
            >
              <!-- <v-icon class="mr-2"> mdi-{{ tab.icon }} </v-icon> -->
              <iconSport :idSport="tab.id_sport" class="mr-2" />
              <div class="overline">
                {{ tab.name_sport }}
              </div>
            </v-tab>
          </v-tabs>

          <Table :type="'nextEvents'" :data="sports[0].categories" />

          <div>
            <v-alert
              text
              dense
              type="warning"
              border="left"
              class="ma-4 mb-2"
              v-if="msg_error"
              >{{ msg_error }}</v-alert
            >
          </div>
        </v-card>
      </v-col>

      <v-col v-if="openEvent && !smAndDown" md="6">
        <div class="mt-2 ml-1">
          <router-view />
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Table from "@/components/table/table";
import rulesOdds from "@/mixins/rulesOdds";
import iconSport from "@/components/icon-sport";
export default {
  name: "favorites",
  mixins: [rulesOdds],
  components: {
    Table,
    iconSport,
  },

  data: () => {
    return {
      openEvent: false,
      smAndDown: false,
      loading: false,
      // dialog: false,
      favorites: [],
      sports: [{ categories: [] }],
      msg_error: "",
      listSports: [],
      favoriteSportName: "",
      tab: null,
    };
  },
  computed: {
    // Retrieve Favorite Tournaments
    getFavoritesList() {
      return this.$store.state.favoriteTournaments;
    },
    getSports() {
      return this.$store.state.sports;
    },
    isWorldCup() {
      return this.getFavoritesList.some((item) => item.id_tournament === 31004);
    },
  },

  mounted() {
    // Proteção de Rota
    if (this.getFavoritesList.length == 0) {
      this.$router.push("/");
      return;
    }
    this.mountTabs();
    this.handleFavorites();
    this.checkOpenEvent();
  },

  watch: {
    $route() {
      if (this.$route.name === "favorites") {
        this.handleFavorites();
        this.mountTabs();
      }
      this.checkOpenEvent();
    },

    getFavoritesList() {
      if (this.getFavoritesList.length == 0) {
        this.$router.push("/");
        return;
      }
      this.handleFavorites();
      this.mountTabs();
    },
  },
  methods: {
    checkOpenEvent: function() {
      this.openEvent = this.$route.query.event ? true : false;
      this.smAndDown = this.$vuetify.breakpoint.smAndDown ? true : false;
    },

    // Montando as Tabs
    mountTabs() {
      // reset;
      this.listSports = [];

      // Incluindo o Sport na array de tabs
      this.getSports.forEach((item) => {
        if (
          this.getFavoritesList.some((sport) => sport.id_sport == item.id_sport)
        ) {
          // Retorna o primeiro item que resolver a função;
          let sports = this.getFavoritesList.find(
            (sport) => sport.id_sport == item.id_sport
          );

          this.listSports.push(sports);
        }
      });

      // Setando a Tab Ativa
      this.listSports.forEach((sport, index) => {
        if (this.$route.params.sport == sport.id_sport) {
          this.tab = index;
        }
      });
    },

    getFavoritesEvents: function(body) {
      this.loading = true;
      this.$axios
        .post(this.isWorldCup ? "/tableMain/tournamentsSpecials" : "/player/table/listTournaments", this.$formdata(body))
        .then((resp) => {
          if (resp.status === 200) {
            let data = resp.data.sports;
            data.forEach(async (item) => {
              await this.editDataSports(item.categories);
            });
            this.sports = data;
            this.msg_error = "";
          }
        })
        .catch((error) => {
          this.sports = [{ categories: [] }];
          this.msg_error = error.response.data.messages.error;
          const msg = this.msg_error;
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        })
        .finally(() => (this.loading = false));
    },

    // Recuperando os Eventos
    handleFavorites() {
      // 1. Caso seja removido o último item de um sport favorito
      // tratar a rota
      if (
        !this.getFavoritesList.some(
          (sport) => sport.id_sport == this.$route.params.sport
        )
      ) {
        this.$router.replace({
          name: "favorites",
          params: { sport: this.getFavoritesList[0].id_sport },
          query: { sport: this.getFavoritesList[0].name_sport },
        });
        return;
      }

      // 2. Tratamento do Body
      const body = {
        domain: this.$domain(),
      };
      this.getFavoritesList.forEach((item, index) => {
        if (this.$route.params.sport == item.id_sport) {
          body[`tournaments[${index}]`] = item.id_tournament;
        }
      });

      // 2.1 request favorites
      this.getFavoritesEvents(body);
    },
  },
};
</script>
